import { render } from "./ModalDaiwariError.vue?vue&type=template&id=12190238&scoped=true"
import script from "./ModalDaiwariError.vue?vue&type=script&lang=js"
export * from "./ModalDaiwariError.vue?vue&type=script&lang=js"

import "./ModalDaiwariError.vue?vue&type=style&index=0&id=12190238&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12190238"]])

export default __exports__